import PetHome from './PetHome';

const ACTION = {
  ...PetHome.ACTION,
};

const ACTION_TYPES = {
  ...PetHome.ACTION_TYPES,
};

const Pet = {
  ACTION,
  ACTION_TYPES
}

export default Pet;